import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CurrentEvaluacionState {
	completada: boolean;
	hasRespuestas: boolean;
	numeroEvaluacion: number;
}

const initialState: CurrentEvaluacionState = null as any;

const currentEvaluacionStateSlice = createSlice({
	name: 'currentEvaluacionState',
	initialState,
	reducers: {
		setCurrentEvaluacionState: (state, action: PayloadAction<CurrentEvaluacionState>) => {
			return action.payload;
		},
		resetCurrentEvaluacionState: () => {
			return initialState;
		}
	}
});

export const { setCurrentEvaluacionState, resetCurrentEvaluacionState } = currentEvaluacionStateSlice.actions;

export default currentEvaluacionStateSlice.reducer;
